import { render } from "./TranferData.vue?vue&type=template&id=ae6ecc8c&scoped=true"
import script from "./TranferData.vue?vue&type=script&lang=js"
export * from "./TranferData.vue?vue&type=script&lang=js"

import "./TranferData.vue?vue&type=style&index=0&id=ae6ecc8c&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae6ecc8c"]])

export default __exports__